module.exports = __webpack_public_path__ + "static/media/c8aef882.jpg";